import { RootState } from "./store";
import { NETWORK_TYPE, NetworkType } from "utils/network";

export const networkSelector = (state: RootState) => state.user.network;

/**
 * The network to send to the API. Returns a plain string, so components can
 * subscribe to it without a memoised selector.
 */
export const networkTypeSelector = (state: RootState): NetworkType =>
  state.user.network?.value ?? NETWORK_TYPE;
export const authUidSelector = (state: RootState) => state.user.authUid;
export const merchantIdSelector = (state: RootState) => state.user.merchantId;
export const merchantInfoSelector = (state: RootState) =>
  state.user.merchantInfo;
export const merchantMetadataSelector = (state: RootState) =>
  state.user.merchantMetadata;
export const merchantBalanceSelector = (state: RootState) =>
  state.user.merchantBalance;
export const merchantTransactionsSelector = (state: RootState) =>
  state.user.merchantTransactions;
export const userTypeSelector = (state: RootState) => state.user.userType;
export const showLoadMoreSelector = (state: RootState) =>
  state.user.showLoadMore;

export const cardNumberByAddressSelector =
  (address: string) => (state: RootState) =>
    state.user.cardNumberMap[address];
export const cardNumberByAddressMapSelector = (state: RootState) =>
  state.user.cardNumberMap;

/** Raw preference — read via useSettlementToken, which validates it against the live list. */
export const settlementTokenAddressSelector = (state: RootState) =>
  state.user.settlementTokenAddress;
